import { FC, useEffect } from "react";
import { useDropzone } from 'react-dropzone';
import { Loader } from './Loader';
import { FileUploadIcon } from '../assets/FileUploadIcon';
import { FilesIcon } from '../assets/FilesIcon';
import { ErrorIcon } from '../assets/ErrorIcon';
import { RemoveIcon } from '../assets/RemoveIcon';

const DROPZONE_OPTIONS = {
    noClick: true,
    noKeyboard: true,
    maxFiles: 5,
    accept: [".pdf", ".jpeg", ".jpg", ".png"]
}

const NoFiles: FC = () => {
    return (
        <>
            <FileUploadIcon />
            <p>No files uploaded</p>
        </>
    )
}

interface FilesProps {
    /*eslint no-empty-pattern: "off"*/
    files: File[];
    clearFile: (file: File) => void;
}

const Files: FC<FilesProps> = ({ files, clearFile }) => {
    return (
        <>
            {files.map(file => (
                <div className="dropzone__status__file" key={file.name}>
                    <FilesIcon />
                    <div className="u-m__l">
                        <div className="dropzone__status__file__name">
                            <p className="u-m__r">{file.name}</p>
                            <RemoveIcon
                                size={25}
                                className="remove-icon"
                                onClick={() => clearFile(file)}
                                role={"button"}
                                tabIndex={0}
                            />
                        </div>

                        <p className="dropzone__status__file__meta">{file.type.split('/')[1].toUpperCase()}, {(file.size / 1000000).toFixed(2)}mb</p>
                    </div>
                </div>
            ))}
        </>
    )
}

const isNiNUmberValid = (niNumber: string): boolean => {
    if (!niNumber || !niNumber.match(/^(?!BG|GB|NK|KN|TN|NT|ZZ)[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z](?:\s*\d{2}){3}\s*[A-D]$/)) {
        return false;
    }

    return true;
}

const isPayDateValid = (paydate: string): boolean => {
    if (!paydate || !paydate.match(/^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/]\d{4}$/)) {
        return false;
    }

    return true;
}

const isNetPayValid = (netPay: string): boolean => {
    if (!netPay || !netPay.match(/^(?:[\$€£])?\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?$/)) {
        return false;
    }
    
    return true;
}


interface FileControlProps {
    uploadState: string;
    fileState: File[];
    setFileState: ([]) => void;
    setShowFileControl: (show: boolean) => void;
    maxFiles: number;
    resetAllowedMaxFiles?: () => void;
    incomeDocType: string;
    setNiValue: (value: string) => void;
    setNetPayValue: (value: string) => void;
    setWageSlipDate: (value: string) => void;
    setNiError: (value: string) => void;
    setNetPayError: (value: string) => void;
    setWageSlipDateError: (value: string) => void;
    niError: string;
    netPayError: string;
    wageSlipDateError: string;
    index: number;
}


export const FileControl: FC<FileControlProps> = ({ uploadState, fileState, incomeDocType, setNiValue, 
    setNetPayValue, setWageSlipDate, index,
    setNiError,
    setNetPayError,
    setWageSlipDateError,
    niError,
    netPayError,
    wageSlipDateError,
    setFileState, setShowFileControl, maxFiles, resetAllowedMaxFiles }) => {
    const { fileRejections, getRootProps, getInputProps, open, acceptedFiles } = useDropzone({ ...DROPZONE_OPTIONS, maxFiles: maxFiles });
    useEffect(() => {
        setFileState(acceptedFiles); resetAllowedMaxFiles && resetAllowedMaxFiles();
    }, [acceptedFiles, resetAllowedMaxFiles])

    const clearFile = (file: File) => {
        const newFiles = acceptedFiles.splice(acceptedFiles.indexOf(file), 1);
        acceptedFiles.splice(acceptedFiles.indexOf(file), 1);
        setFileState(newFiles);
        if (fileState.length === 0) {
            setFileState([]);
            setShowFileControl(false);
        }
    }
	// const [invalidDateOfPaySlip, setInvalidDateOfPaySlip] = useState('');
    const filesStaged = fileState?.length > 0;

    const fileRejectionItems = fileRejections.map(({ errors }) => {

        return (
            errors?.length > 0 ? errors[0].message : ''
        )
    });

    return <div>
        {incomeDocType === 'WAGE' && 
            <div>
                    <fieldset className="u-m__t--l u-m__b--l">
						<label htmlFor={`uploadDetails[${index}].ni`} className="form__label">National Insurance Number</label>
						<input id={`uploadDetails[${index}].ni`} className="form__input u-m__t u-m__b--s" type="text" onChange={(value) => {
                            if(isNiNUmberValid(value.currentTarget.value)) {
                                setNiValue(value.currentTarget.value);
                            } else {
                                setNiError('NI Number not valid, correct format AA123456C')
                            }
						}} />
						<span style={{ color: "red" }}>{niError}</span>
					</fieldset>
                    <fieldset className="u-m__t--l u-m__b--l">
						<label htmlFor={`uploadDetails[${index}].netPay`} className="form__label">Net Pay</label>
						<input id={`uploadDetails[${index}].netPay`} className="form__input u-m__t u-m__b--s" type="text" onChange={(value) => {
                            if(isNetPayValid(value.currentTarget.value)) {
                            setNetPayValue(value.currentTarget.value);
                            } else {
                                setNetPayError('Invalid netpay');
                            }
						}} />
						<span style={{ color: "red" }}>{netPayError}</span>
					</fieldset>
                    <fieldset className="u-m__t--l u-m__b--l">
						<label htmlFor={`uploadDetails[${index}].wageSlipDate`} className="form__label">Pay Slip Date*</label>
                        <input id={`uploadDetails[${index}].wageSlipDate`}  className="form__input u-m__t" type="text" placeholder="dd/mm/yyyy" onChange={(value) => {
                        if(isPayDateValid(value.currentTarget.value)) {
                            setWageSlipDate(value.currentTarget.value)
                        } else {
                            setWageSlipDateError('Invalid wage slip date, should be in format: dd/mm/yyyy');
                        }
						}} />
						<span style={{ color: "red" }}>{wageSlipDateError}</span>
					</fieldset>
                </div>}
        <div {...getRootProps({ className: 'dropzone u-p ' })}>
        <input className="form__input" {...getInputProps()} />

        <div className="dropzone__status">
            {uploadState === 'none' && !filesStaged && <NoFiles />}
            {uploadState === 'none' && filesStaged && <Files files={fileState} clearFile={clearFile} />}
            {uploadState === 'loading' && <Loading />}
            {(uploadState === 'error' || fileRejectionItems?.length > 0) && <Error errorMsg={fileRejectionItems} />}
        </div>

        {uploadState !== 'loading' && (
            <button className={`${filesStaged ? "btn--ghost" : "btn"} u-m__t`} onClick={open}>
                Select File
            </button>)}

    </div>
    </div>
}

interface ErrorProps {
    errorMsg?: string[];
}
const Error: FC<ErrorProps> = ({ errorMsg }) => {
    return (
        <>
            <ErrorIcon height={32} />
            <p className="verification-error">Something went wrong.</p>
            {errorMsg && errorMsg.length > 0 && <p className="verification-error">{errorMsg[0]}</p>}
        </>
    );
}

const Loading: FC = () => {
    return (
        <div>
            <Loader className="loading-anchor" />
            <p>Uploading your file.</p>
        </div>
    );
}